import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, signal } from "@angular/core";
import { getAuth } from "@angular/fire/auth";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { FUNCTION_RESULT_STATUS, IPlatformUser } from "@nova/common-interfaces";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";

@Component({
  selector: "app-billing-sidebar",
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: "./billing-sidebar.component.html",
  styleUrl: "./billing-sidebar.component.scss",
})
export class BillingSidebarComponent implements OnInit {
  isDropdownOpen: { [key: string]: boolean } = {};
  isLoggedIn = false;
  public customer_overview = signal<ICustomerOverview | undefined>(undefined);
  env = environment.production;
  hasSubscriptions = false;
  isCustomerActive = false;
  email: string | undefined;

  @Input()
  user: IPlatformUser | undefined;

  constructor(private authService: AuthService, private customerService: CustomerService, private router: Router) {
    this.authService.isLoggedIn$.subscribe((x) => {
      this.isLoggedIn = x;

      if (x) {
        this.authService.isLoggedIn$.subscribe((state) => {
          const uid = getAuth().currentUser?.uid;
          this.isLoggedIn = state;
          if (state === false) {
            this.customer_overview.set(undefined);
            this.hasSubscriptions = false;
          } else {
            this.customerService
              .getOverview(uid!, true)
              .then(async (x) => {
                if (x.status === FUNCTION_RESULT_STATUS.SUCCESS) {
                  this.customer_overview.set(x.data);

                  if (!environment.production) {
                    console.log("OVERVIEW RESULT", this.customer_overview());
                  }

                  if (
                    this.customer_overview() &&
                    this.customer_overview()?.subscriptions &&
                    this.customer_overview()?.subscriptions?.data &&
                    this.customer_overview()?.subscriptions?.data.length! > 0
                  ) {
                    this.hasSubscriptions = true;
                  }
                }
              });
          }
        });
      }
    });
  }

  ngOnInit(): void {}

  logout() {
    this.authService
      .signOut()
      .then(() => {
        console.log("User logged out");
        this.customer_overview.set(undefined);
        this.router.navigate(["/login"]); // Redirect to login page
      })
      .catch((error) => {
        console.error("Error during logout:", error);
      });
  }

  toggleDropdown(menu: string): void {
    this.isDropdownOpen[menu] = !this.isDropdownOpen[menu];
  }
}
